import React from "react";

import Pagination from "react-bootstrap/Pagination";

const TablePagination = ({
  pageNumber,
  setPageNumber,
  totalPages,
  totalRows,
}) => {
  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const renderTotalRows = () => {
    if (!totalRows) return null;

    if (totalRows === 0) {
      return <p>Nenhum registro encontrado</p>;
    }

    return (
      <div className="row">
        <label>Total de registros: {totalRows}</label>
      </div>
    );
  };

  const renderPagination = () => {
    if (totalPages === 0) return null;

    return (
      <Pagination>
        <Pagination.First
          onClick={() => handlePageChange(1)}
          disabled={pageNumber === 1}
        />
        <Pagination.Prev
          onClick={() => handlePageChange(pageNumber - 1)}
          disabled={pageNumber === 1}
        />
        {getPages(totalPages, pageNumber).map((page) => (
          <Pagination.Item
            key={page}
            active={page === pageNumber}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => handlePageChange(pageNumber + 1)}
          disabled={pageNumber === totalPages}
        />
        <Pagination.Last
          onClick={() => handlePageChange(totalPages)}
          disabled={pageNumber === totalPages}
        />
      </Pagination>
    );
  };

  return (
    <div>
      {renderPagination()}
      {renderTotalRows()}
    </div>
  );
};

const getPages = (totalPages, pageNumber) => {
  const pages = [];
  const maxPages = 5;

  if (totalPages <= maxPages) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    let start = 1;
    let end = maxPages;

    if (pageNumber > 2) {
      start = pageNumber - 2;
      end = pageNumber + 2;
    }

    if (end > totalPages) {
      start = totalPages - 4;
      end = totalPages;
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
  }
  return pages;
};

export default TablePagination;
